import React from 'react';
import './HeaderFooter.css'

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <p>&copy; {new Date().getFullYear()} educationvb.com</p>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
